var media_desktop   = 1024,
    media_laptop    = 900,
    media_tablet    = 768,
    media_mobile    = 320;

$(window).on('load',function(){
    
    if($(window).width() <= media_desktop){
        
        if($(window).width() < media_laptop){
            
            if($(window).width() < media_tablet){
                
                if(!$('html').hasClass('mobile')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('tablet');
                    $('html').addClass('mobile');
                }
            }
            else{
                
                if(!$('html').hasClass('tablet')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('mobile');
                    $('html').addClass('tablet');
                }
            }
            
        }
        else{
            
            if(!$('html').hasClass('laptop')){
                $('html').removeClass('desktop').removeClass('tablet').removeClass('mobile');
                $('html').addClass('laptop');
            }
        }
    }
    else{
        
        if(!$('html').hasClass('desktop')){
            $('html').removeClass('laptop').removeClass('tablet').removeClass('mobile');
            $('html').addClass('desktop');
        }
    }
    
    init_slide();
});

$(window).resize(function(){
    
    if($(window).width() <= media_desktop){
        
        if($(window).width() < media_laptop){
            
            if($(window).width() < media_tablet){
                
                if(!$('html').hasClass('mobile')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('tablet');
                    $('html').addClass('mobile');
                    
                    startSlide();
                }
            }
            else{
                
                if(!$('html').hasClass('tablet')){
                    $('html').removeClass('desktop').removeClass('laptop').removeClass('mobile');
                    $('html').addClass('tablet');
                    
                    startSlide();
                }
            }
            
        }
        else{
            
            if(!$('html').hasClass('laptop')){
                $('html').removeClass('desktop').removeClass('tablet').removeClass('mobile');
                $('html').addClass('laptop');
                    
                    startSlide();
            }
        }
    }
    else{
        
        if(!$('html').hasClass('desktop')){
            $('html').removeClass('laptop').removeClass('tablet').removeClass('mobile');
            $('html').addClass('desktop');
                    
                    startSlide();
        }
    }
});

function init_slide(){
    
    slider = [];
    
    $('[data-slide]').each(function(){
        var o = "",
            e = jQuery(this),
            i = 0;

        if($('html').hasClass('desktop')){
            o = $(this).data('slide').desktop;
        }else{
            if($('html').hasClass('laptop')){
                o = $(this).data('slide').laptop;
            }else{
                if($('html').hasClass('tablet')){
                    o = $(this).data('slide').tablet;
                }else{
                    o = $(this).data('slide').mobile;
                }
            }
        }
        
        var minItems = parseInt(defaultValue('1',o.minItems));
        
        if(minItems < $('> *', e).length){
            var settings = {
                    mode                : defaultValue('horizontal',o.mode).toString(),
                    speed               : parseInt(defaultValue('500',o.speed)),
                    pause               : parseInt(defaultValue('4000',o.speed)),
                    slideMargin         : parseInt(defaultValue('0',o.slideMargin)),
                    startSlide          : parseInt(defaultValue('0',o.startSlide)),
                    randomStart         : JSON.parse(defaultValue('false',o.randomStart)),
                    infiniteLoop        : JSON.parse(defaultValue('true',o.infiniteLoop)),
                    hideControlOnEnd    : JSON.parse(defaultValue('false',o.hideControlOnEnd)),
                    adaptiveHeight      : JSON.parse(defaultValue('false',o.adaptiveHeight)),
                    adaptiveHeightSpeed : parseInt(defaultValue('500',o.adaptiveHeightSpeed)),
                    responsive          : JSON.parse(defaultValue('true',o.responsive)),
                    touchEnabled        : JSON.parse(defaultValue('true',o.touchEnabled)),
                    swipeThreshold      : parseInt(defaultValue('50',o.swipeThreshold)),
                    pager               : JSON.parse(defaultValue('true',o.pager)),
                    pagerType           : defaultValue('full',o.pagerType).toString(),
                    pagerShortSeparator : defaultValue('/',o.pagerShortSeparator).toString(),
                    controls            : JSON.parse(defaultValue('true',o.controls)),
                    nextText            : defaultValue('Next',o.nextText).toString(),
                    prevText            : defaultValue('Prev',o.prevText).toString(),
                    autoControls        : JSON.parse(defaultValue('false',o.autoControls)),
                    startText           : defaultValue('Start',o.startText).toString(),
                    stopText            : defaultValue('Stop',o.stopText).toString(),
                    autoControlsCombine : JSON.parse(defaultValue('false',o.autoControlsCombine)),
                    auto                : JSON.parse(defaultValue('false',o.auto)),
                    stopAutoOnClick     : JSON.parse(defaultValue('false',o.stopAutoOnClick)),
                    autoDirection       : defaultValue('next',o.autoDirection).toString(),
                    autoHover           : JSON.parse(defaultValue('false',o.autoHover)),
                    autoDelay           : parseInt(defaultValue('0',o.autoDelay)),
                    minSlides           : parseInt(defaultValue('1',o.minSlides)),
                    maxSlides           : parseInt(defaultValue('1',o.maxSlides)),
                    moveSlides          : parseInt(defaultValue('0',o.moveSlides)),
                    slideWidth          : parseInt(defaultValue('0',o.slideWidth)),
                    shrinkItems         : JSON.parse(defaultValue('false',o.shrinkItems)),
                    keyboardEnabled     : JSON.parse(defaultValue('false',o.keyboardEnabled)),
                    ariaLive            : JSON.parse(defaultValue('true',o.ariaLive)),
                    ariaHidden          : JSON.parse(defaultValue('true',o.ariaHidden)),
                    onSliderLoad        : function(){
                        jQuery('> *:not(.bx-clone):eq('+parseInt(defaultValue('0',o.startSlide))+')',e).addClass('active');
                    },
                    onSlideBefore: function(currentSlideNumber,oldIndex,newIndex){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                    },
                    onSlideAfter: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                    }
            };
        
            slider.push($(this).bxSlider(settings));
        }
        
    });
}

function startSlide(){
    
    var i = 0;
    
    $('[data-slide]').each(function(){
        var o = "",
            e = jQuery(this);
        
        if($('html').hasClass('desktop')){
            o = $(this).data('slide').desktop;
        }else{
            if($('html').hasClass('laptop')){
                o = $(this).data('slide').laptop;
            }else{
                if($('html').hasClass('tablet')){
                    o = $(this).data('slide').tablet;
                }else{
                    o = $(this).data('slide').mobile;
                }
            }
        }
        
        var minItems = parseInt(defaultValue('1',o.minItems));
        
        if(minItems < $('> *', e).length){
            var settings = {
                    mode                : defaultValue('horizontal',o.mode).toString(),
                    speed               : parseInt(defaultValue('500',o.speed)),
                    pause               : parseInt(defaultValue('4000',o.speed)),
                    slideMargin         : parseInt(defaultValue('0',o.slideMargin)),
                    startSlide          : parseInt(defaultValue('0',o.startSlide)),
                    randomStart         : JSON.parse(defaultValue('false',o.randomStart)),
                    infiniteLoop        : JSON.parse(defaultValue('true',o.infiniteLoop)),
                    hideControlOnEnd    : JSON.parse(defaultValue('false',o.hideControlOnEnd)),
                    adaptiveHeight      : JSON.parse(defaultValue('false',o.adaptiveHeight)),
                    adaptiveHeightSpeed : parseInt(defaultValue('500',o.adaptiveHeightSpeed)),
                    responsive          : JSON.parse(defaultValue('true',o.responsive)),
                    touchEnabled        : JSON.parse(defaultValue('true',o.touchEnabled)),
                    swipeThreshold      : parseInt(defaultValue('50',o.swipeThreshold)),
                    pager               : JSON.parse(defaultValue('true',o.pager)),
                    pagerType           : defaultValue('full',o.pagerType).toString(),
                    pagerShortSeparator : defaultValue('/',o.pagerShortSeparator).toString(),
                    controls            : JSON.parse(defaultValue('true',o.controls)),
                    nextText            : defaultValue('Next',o.nextText).toString(),
                    prevText            : defaultValue('Prev',o.prevText).toString(),
                    autoControls        : JSON.parse(defaultValue('false',o.autoControls)),
                    startText           : defaultValue('Start',o.startText).toString(),
                    stopText            : defaultValue('Stop',o.stopText).toString(),
                    autoControlsCombine : JSON.parse(defaultValue('false',o.autoControlsCombine)),
                    auto                : JSON.parse(defaultValue('false',o.auto)),
                    stopAutoOnClick     : JSON.parse(defaultValue('false',o.stopAutoOnClick)),
                    autoDirection       : defaultValue('next',o.autoDirection).toString(),
                    autoHover           : JSON.parse(defaultValue('false',o.autoHover)),
                    autoDelay           : parseInt(defaultValue('0',o.autoDelay)),
                    minSlides           : parseInt(defaultValue('1',o.minSlides)),
                    maxSlides           : parseInt(defaultValue('1',o.maxSlides)),
                    moveSlides          : parseInt(defaultValue('0',o.moveSlides)),
                    slideWidth          : parseInt(defaultValue('0',o.slideWidth)),
                    shrinkItems         : JSON.parse(defaultValue('false',o.shrinkItems)),
                    keyboardEnabled     : JSON.parse(defaultValue('false',o.keyboardEnabled)),
                    ariaLive            : JSON.parse(defaultValue('true',o.ariaLive)),
                    ariaHidden          : JSON.parse(defaultValue('true',o.ariaHidden)),
                    onSliderLoad        : function(){
                        jQuery('> *:not(.bx-clone):eq('+parseInt(defaultValue('0',o.startSlide))+')',e).addClass('active');
                    },
                    onSlideBefore: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-prev',sliderShared).click();
                            }
                    },
                    onSlideAfter: function(currentSlideNumber){
                        jQuery('> .active',e).removeClass('active');
                        currentSlideNumber.addClass('active');
                        jQuery('> *',e).addClass('eff_slide');
                        setTimeout(function(){
                            jQuery('> *',e).removeClass('eff_slide');
                        },300);
                        
                        if(!e.closest('.j-sharedAux').length)
                            if($('.js-sliderShared').length){
                                var sliderShared = e.closest('.js-sliderShared');
                                $('.j-sharedAux .bx-next',sliderShared).click();
                            }
                    }
            };

            slider[i].reloadSlider(settings);

            i++;
        }
        
    });
}

// GLOBAL

function defaultValue(def,value){
    
    typeof value === "undefined" ?
        val = def:
        val = value;
    
    return val;
}

$(window).on('load',function(){
    
    //[Scroll Menu]
    if($('[class^="mdl-header"]').length)
        if($(window).scrollTop() > 0){
            $('[class^="mdl-header"]').addClass('scroller');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scroller');
        }
})
.on('scroll',function(){
    
    //[Scroll Menu]
    if($('[class^="mdl-header"]').length)
        if($(window).scrollTop() > 0){
            $('[class^="mdl-header"]').addClass('scroller');
        }
        else{
            $('[class^="mdl-header"]').removeClass('scroller');
        }
});


//Efectos de carga y scroll
$(window).on('load', function(){
    
    $('.eff-init_trans').each(function(){
        $(this).removeClass('eff-init_trans');
    });
    
    $('.eff-noactive').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true) * 1.2)){
            o.addClass('eff-active');
            
            setTimeout(function(){
                o.removeClass('eff-noactive');
                o.removeClass('eff-active');
            },0);
        }
    });
    
    $('.eff-noactiveimg').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activeimg');
            
            setTimeout(function(){
                o.removeClass('eff-noactiveimg');
            },0);
        }
    });
})
.scroll(function(){
    
    $('.eff-noactive').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-active');
            
            setTimeout(function(){
                o.removeClass('eff-noactive');
                o.removeClass('eff-active');
            },0);
        }
    });
    
    $('.eff-noactiveimg').each(function(){
        var o = $(this);
        
        if($(window).scrollTop() > (o.offset().top - $(window).outerHeight(true))){
            o.addClass('eff-activeimg');
            
            setTimeout(function(){
                o.removeClass('eff-noactiveimg');
            },0);
        }
    });
});

/*Accordion*/
$(function(){
    
    if($('.js-accordion').length)defaultAccordion();

});

function defaultAccordion(){
    
    $('.js-accordion').each(function(){
        var o = $(this),
            parent = o.parent();
        
        $('> .js-header',o).first().click(function(){
            
            if(!o.hasClass('open')){
                $('.js-accordion.open > .js-section',parent).slideUp();
                $('.js-accordion.open',parent).removeClass('open');
            }

            $('> .js-section',o).first().slideToggle();
            o.toggleClass('open');
            
        });
    });

    $('.m-users').on('click', function(){
        var o = $(this);

        $('.m-user .m-10').slideToggle();
        o.toggleClass('open');
    });
}

/*Form element active*/
$(document).on('keypress change', 'input', function() {
    
   $(this).val().length != 0 ?
      $(this).parent().addClass('active'):
      $(this).parent().removeClass('active');
});


/*Overflow hidden page on click*/
$(window).on('load', function(){
    if($('#sta-css-header').length)
        $('#sta-css-header').click(function(){            
            $('html').toggleClass('over-hidden');
            
            if($('html').hasClass('over-hidden')){
                scroll_o = $(window).scrollTop();
            }
            else{
                $('body').css({'position': 'static'});
                $(window).scrollTop(scroll_o);
            }
        });
});